module.exports = __webpack_public_path__ + "static/media/plus.8b200d89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/plus.jpg
// module id = 438
// module chunks = 0